module.exports = __webpack_public_path__ + "img/money33.6ab6fc8f.jpeg";